import { render, staticRenderFns } from "./highwaySafety.vue?vue&type=template&id=39d58c41&scoped=true"
import script from "./highwaySafety.vue?vue&type=script&lang=js"
export * from "./highwaySafety.vue?vue&type=script&lang=js"
import style0 from "./highwaySafety.vue?vue&type=style&index=0&id=39d58c41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d58c41",
  null
  
)

export default component.exports